import '../App.css';
import CallNowBlock from "./CallNowBlock";
import Footer from "./Footer";
import Head from "./Head";

import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import ScrollToTop from "./Util";
import VehicleList from "./listing/VehicleList";
import Main from "./Main";
import VehicleOrderMain from "./vehicleorder/VehicleOrderMain";
import Loan from "./Loan";
import Service from "./servise/Service";
import Commission from "./comission/Commission";
import CommisssionQuestions from "./comission/CommissionQuestions";
import Contacts from "./Contacts";
import Address from "./contact/Address";
import {theme} from "./MuiCustomization";
import {ThemeProvider} from "@mui/material";
import Blog from "./blog/Blog";
import {useEffect, useState} from "react";
import PageBreadcrumbs from "./PageBreadcrumbs";
import ReactGA from "react-ga4";
import VehicleOrderPricingInfo from "./vehicleorder/VehicleOrderPricingInfo";
import ServicePrice from "./servise/ServicePrice";
import TirePrice from "./servise/TirePrice";
import {LISTING_ALL_PAGE_TYPE, LISTING_MOTO_PAGE_TYPE, LISTING_ORDER_PAGE_TYPE} from "./Constants";
import Article from "./blog/Article";
import TireStorage from "./servise/TireStorage";
import Information, {PrivacyPolicyDocument} from "./Information";

export default function App() {

    const [currencyExchangeRate, setCurrencyExchangeRate] = useState();

    ReactGA.initialize("G-9HG84DY6BL");

    useEffect(() => {
        fetch("/api/currency/usd")
            .then(response => {
                return response.json();
            })
            .then(data => {
                setCurrencyExchangeRate(data);
            })
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <Head/>
                <PageBreadcrumbs/>
                <ScrollToTop/>
                {/* Router functionality */}
                <Routes>
                    <Route path='/' element={<Main/>}/>

                    <Route path='/listing' key={LISTING_ALL_PAGE_TYPE}
                           element={<VehicleList pageType={LISTING_ALL_PAGE_TYPE}
                                                 currencyExchangeRate={currencyExchangeRate}/>}/>
                    <Route path="/listing/brand/:brand"
                           element={<VehicleList pageType={LISTING_ALL_PAGE_TYPE}
                                                 currencyExchangeRate={currencyExchangeRate}/>}/>
                    <Route path="/listing/:articleId"
                           element={<VehicleList pageType={LISTING_ALL_PAGE_TYPE}
                                                 currencyExchangeRate={currencyExchangeRate}/>}/>

                    <Route path='/catalog-moto' key={LISTING_MOTO_PAGE_TYPE}
                           element={<VehicleList pageType={LISTING_MOTO_PAGE_TYPE}
                                                 currencyExchangeRate={currencyExchangeRate}/>}/>
                    <Route path="/catalog-moto/brand/:brand"
                           element={<VehicleList pageType={LISTING_MOTO_PAGE_TYPE}
                                                 currencyExchangeRate={currencyExchangeRate}/>}/>
                    <Route path="/catalog-moto/:articleId"
                           element={<VehicleList pageType={LISTING_MOTO_PAGE_TYPE}
                                                 currencyExchangeRate={currencyExchangeRate}/>}/>

                    <Route path="/vehicleOrder" element={<VehicleOrderMain/>}/>
                    <Route path="/vehicleOrder/catalog" key={LISTING_ORDER_PAGE_TYPE}
                           element={<VehicleList pageType={LISTING_ORDER_PAGE_TYPE}
                                                 currencyExchangeRate={currencyExchangeRate}/>}/>
                    <Route path="/vehicleOrder/catalog/brand/:brand"
                           element={<VehicleList pageType={LISTING_ORDER_PAGE_TYPE}
                                                 currencyExchangeRate={currencyExchangeRate}/>}/>
                    <Route path="/vehicleOrder/catalog/:articleId" key={LISTING_ORDER_PAGE_TYPE}
                           element={<VehicleList pageType={LISTING_ORDER_PAGE_TYPE}
                                                 currencyExchangeRate={currencyExchangeRate}/>}/>
                    <Route path="/vehicleOrder/listing" element={<Navigate to="/vehicleOrder/catalog" replace/>}/>
                    <Route path="/vehicleOrder/pricing" element={<VehicleOrderPricingInfo/>}/>

                    <Route path="/loan" element={<Loan/>}/>

                    <Route path="/service" element={<Service/>}/>
                    <Route path="/service/servicePrice" element={<ServicePrice/>}/>
                    <Route path="/service/tireServicePrice" element={<TirePrice/>}/>
                    <Route path="/service/tireStorage" element={<TireStorage/>}/>

                    <Route path="/commission" element={<Commission/>}/>
                    <Route path="/commissionQuestions" element={<CommisssionQuestions/>}/>
                    <Route path="/contacts" element={<Contacts/>}/>
                    <Route path="/location" element={<Address/>}/>
                    <Route path="/information" element={<Information/>}/>
                    <Route path="/information/privacy-policy" element={<PrivacyPolicyDocument/>}/>

                    <Route path="/blog" element={<Blog/>}/>
                    <Route path="/blog/:articleId" element={<Article/>}/>

                </Routes>

                <CallNowBlock/>
            </BrowserRouter>
            <Footer/>
        </ThemeProvider>
    );

}
